import { Stack } from '@mui/material';
import React from 'react';

type OWFormProps = {
    children: React.ReactNode;
    onSubmit: React.FormEventHandler<HTMLFormElement>;
};

const OWForm = ({ children, onSubmit }: OWFormProps) => {
    return (
        <Stack
            component="form"
            onSubmit={onSubmit}
            noValidate
            width="640px"
            marginInline="auto"
            marginBottom="128px"
            sx={{
                background: 'white',
            }}
            padding={4}
            borderRadius={4}
            spacing={3}
        >
            {children}
        </Stack>
    );
};

export default OWForm;
